import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { WaButton, btnSecondary } from "./ui";
import { scrollToId } from "@/lib/site";

const ease = [0.22, 1, 0.36, 1];
const BENEFITS = ["Asesoría sin costo para ti", "Alternativas según tu presupuesto", "Pensamos también en tu familia"];

const Line = ({ children, i }) => (
  <span className="block overflow-hidden pb-1">
    <motion.span className="block" initial={{ y: "105%" }} animate={{ y: 0 }} transition={{ duration: 0.9, delay: 0.1 + i * 0.12, ease }}>
      {children}
    </motion.span>
  </span>
);

export const Hero = () => (
  <section id="inicio" data-testid="hero-section" className="bg-white pt-40 sm:pt-32">
    <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 pb-14 sm:px-6 lg:grid-cols-2 lg:gap-14 lg:pb-20 lg:pt-8">
      <div>
        <h1 data-testid="hero-title" className="text-[38px] font-extrabold leading-[1.08] tracking-tight text-[#0B3C5D] sm:text-5xl lg:text-[58px]">
          <Line i={0}>¿Buscas un mejor</Line>
          <Line i={1}>plan de <span className="text-[#13766C]">salud?</span></Line>
        </h1>
        <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.4, ease }}
          className="mt-6 max-w-xl text-[19px] leading-relaxed text-[#3A4753] sm:text-xl">
          Te ayudamos a conocer alternativas de planes de Isapre según tus necesidades, tu presupuesto y tu familia. Asesoría personalizada y sin costo para ti.
        </motion.p>
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.55, ease }}
          className="mt-8 flex flex-col gap-3 sm:flex-row">
          <WaButton testId="hero-whatsapp-btn" />
          <button onClick={() => scrollToId("contacto")} data-testid="hero-form-btn" className={btnSecondary}>Dejar mis datos</button>
        </motion.div>
      </div>

      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 0.3, ease }} className="relative">
        <div className="overflow-hidden rounded-2xl">
          <img src="/img/familia.webp" alt="Familia joven con sus dos hijos abrazados y riendo en casa"
            className="aspect-[4/3] w-full object-cover" fetchpriority="high" />
        </div>
        <ul className="relative -mt-12 mx-4 space-y-2.5 rounded-2xl border border-[#E3EAEF] bg-white p-5 shadow-[0_16px_40px_-16px_rgba(11,60,93,.25)] sm:mx-8 lg:absolute lg:-bottom-8 lg:-left-8 lg:mx-0 lg:mt-0 lg:w-[320px]" data-testid="hero-benefits">
          {BENEFITS.map((b) => (
            <li key={b} className="flex items-center gap-3 text-[17px] font-semibold text-[#1F2A33]">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#E3F5F2]"><Check className="h-4 w-4 text-[#13766C]" strokeWidth={3} /></span>{b}
            </li>
          ))}
        </ul>
      </motion.div>
    </div>
  </section>
);
